import { Container, Graphics } from 'pixi.js';

export class OutlineLayer {
  readonly container = new Container();
  private readonly gfx = new Graphics();
  private radius = -1;
  private local = false;

  constructor() {
    this.container.addChild(this.gfx);
  }

  update(radius: number, isLocal: boolean): void {
    if (radius === this.radius && isLocal === this.local) return;
    this.radius = radius;
    this.local = isLocal;
    this.gfx.clear();
    this.gfx.circle(0, 0, radius);
    this.gfx.stroke({ width: 1, color: isLocal ? 0xffffff : 0x000000, alpha: isLocal ? 0.3 : 0.2 });
    if (isLocal) {
      this.gfx.circle(0, 0, radius + 2);
      this.gfx.stroke({ width: 1.5, color: 0xffffff, alpha: 0.5 });
    }
  }

  destroy(): void {
    this.gfx.destroy();
    this.container.removeChildren();
  }
}
